import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b215e01"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "website-detail-view" }
const _hoisted_2 = { class: "modal-header" }
const _hoisted_3 = { class: "ps-2 h6 text-white" }
const _hoisted_4 = {
  key: 0,
  type: "button",
  class: "btn-close btn-close-white",
  "data-bs-dismiss": "modal",
  "aria-label": "Close",
  ref: "closeBtn"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "p-2 settings min-vh-100 text-center pt-10 w-100" }
const _hoisted_7 = {
  class: "mt-10 text-white",
  "data-bs-dismiss": "modal"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 0,
  class: "d-flex p-2 settings justify-content-center -mt-2 pb-3"
}
const _hoisted_12 = { class: "mt-2.5" }
const _hoisted_13 = { class: "me-5 ms-5 text-gray-100 px-2 py-2.5 rounded text-nowrap bg-red-400" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-white font-bold" }, "vs.", -1))
const _hoisted_15 = ["value"]
const _hoisted_16 = {
  key: 1,
  class: "text-center text-white flex-1 justify-content-center mb-4"
}
const _hoisted_17 = {
  key: 3,
  class: "text-danger mt-5 pt-5 text-center"
}
const _hoisted_18 = { key: 4 }
const _hoisted_19 = { class: "px-3 mx-5 mt-4 mb-3" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "position-relative" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "position-absolute w-full text-center text-dark pe-2" }, "Differences"),
  /*#__PURE__*/_createElementVNode("div", { class: "position-absolute w-full text-right text-dark" }, "Current"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-dark" }, "Previous")
], -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "visualChangesViewer",
  style: {"display":"flex","justify-content":"center","position":"relative","overflow":"auto"}
}, [
  /*#__PURE__*/_createElementVNode("canvas", {
    id: "canvas3",
    width: "1280",
    height: "4000",
    style: {}
  }),
  /*#__PURE__*/_createElementVNode("canvas", {
    id: "canvas1",
    width: "1280",
    height: "4000",
    style: {"position":"absolute","opacity":"0.5"}
  }),
  /*#__PURE__*/_createElementVNode("canvas", {
    id: "canvas2",
    width: "1280",
    height: "4000",
    style: {"position":"absolute","opacity":"0.5"}
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_loading_spinner = _resolveComponent("loading-spinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.website.url), 1),
      (_ctx.$route.name != 'website')
        ? (_openBlock(), _createElementBlock("button", _hoisted_4, null, 512))
        : _createCommentVNode("", true),
      (_ctx.$route.name == 'website')
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 1,
            to: { name: 'index' },
            type: "button",
            class: "btn-close btn-close-white position-absolute right-3 top-3"
          }))
        : _createCommentVNode("", true)
    ]),
    (_ctx.showPayWall)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("p", _hoisted_7, [
              _createTextVNode("You have reached the end of your 2 month trial."),
              _hoisted_8,
              _createTextVNode(" Now you have to upgrade your workspace to a paid plan (starts at 6$)."),
              _hoisted_9,
              _createVNode(_component_router_link, { to: { name: 'payment' } }, {
                default: _withCtx(() => [
                  _createTextVNode(" Upgrade Now ")
                ]),
                _: 1
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.showPayWall)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          (_ctx.historyItems.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.format(_ctx.selectedPrevItem?.updatedAt)), 1),
                  _hoisted_14
                ]),
                (_ctx.historyItems.length)
                  ? _withDirectives((_openBlock(), _createElementBlock("select", {
                      key: 0,
                      class: "rounded py-2.5 px-2 me-5 ms-5 bg-green-500",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.slimSelectedItemTimestamp) = $event))
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.historyItems, (item) => {
                        return (_openBlock(), _createElementBlock("option", {
                          class: "text-dark",
                          value: item.timestamp,
                          key: item.timestamp
                        }, _toDisplayString(_ctx.format(item.updatedAt)), 9, _hoisted_15))
                      }), 128))
                    ], 512)), [
                      [_vModelSelect, _ctx.slimSelectedItemTimestamp]
                    ])
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_16, " No history yet ")),
          (!_ctx.loaded && !_ctx.error)
            ? (_openBlock(), _createBlock(_component_loading_spinner, {
                key: 2,
                class: "mt-5 pt-5"
              }))
            : _createCommentVNode("", true),
          (!_ctx.loaded && _ctx.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.error), 1))
            : _createCommentVNode("", true),
          (_ctx.loaded)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _withDirectives(_createElementVNode("input", {
                    type: "range",
                    id: "mixer",
                    name: "mixer",
                    min: "0",
                    max: "100",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.mixer) = $event)),
                    class: "from-control w-full"
                  }, null, 512), [
                    [_vModelText, _ctx.mixer]
                  ])
                ]),
                _hoisted_21,
                _hoisted_22
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}